// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"1b6337da","213":"dc82f80b","239":"16242d41","318":"2038c4c8","404":"920a392d","455":"adc9cf38","727":"0bd5af52","836":"d7f1e840"}[chunkId] + ".chunk.js";
};